import type { RaRecord } from "ra-core";

/** Same as the desktop forms: https:// before a website without it */
export const withWebsiteProtocol = <T extends Partial<RaRecord>>(
  values: T & { website?: string | null },
): T => {
  const website = values.website;
  return website && !website.startsWith("http")
    ? { ...values, website: `https://${website}` }
    : values;
};
